import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Password } from 'primereact/password';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';

import logo from '../../img/banobras.jpg';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioLogin from '../servicios/ServicioLogin'
import NuevoRegistro from './NuevoRegistro';
import RecuperarContrasena from './RecuperarContrasena';
import servicioRecuperaFactura from '../servicios/ServicioRecuperaNru';
import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos'
import Manual from './Manual';
export class Login extends Component {
	constructor() {
		super();
		this.state = {
			value: null,
			usuario: {},
			erroresFrmLogin: {},
			modalRecuperarNru: false,
			errores:{},
			nrucorreo:{}
		};
		localStorage.removeItem("auth");
	}

	asignarValoresObjeto = (event) => {
		servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
	}

	validarFormularioLogin = (usuario) => {
		const errores = {};
		if (!usuario.usuario)
			errores.usuario = "El usuario es requerido";
		if (!usuario.contrasena)
			errores.contrasena = "El password es requerido";
		return errores;
	}

	login = (event) => {
		event.preventDefault();
		let { usuario } = this.state;
		const resultadoValidacion = this.validarFormularioLogin(usuario);
		this.setState({ erroresFrmLogin: resultadoValidacion });
		if (!Object.keys(resultadoValidacion).length) {
			localStorage.removeItem("auth");
			servicioLogin.buscarUsuario(usuario.usuario, usuario.contrasena).then(response => {
				localStorage.setItem('auth', response.headers.authorization);
				window.location = '/facturacionbanobras/bienvenido';
			}).catch(error => {
				this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Usuario o contraseña inválidas' });
			});

		}
	}

	validarFormularioNru = (nrucorreo) => {
		const errores = {};
		if (!nrucorreo.nru)
			errores.nru = "El nru es requerido";
		if (!nrucorreo.correo)
			errores.correo = "El correo es requerido";
		return errores;
	}

	recuperarFactura = () => {
		this.setState({ modalRecuperarNru: true,nrucorreo:{}  });
	}

	buscarFactura=()=>{
		const {nrucorreo}=this.state;
		const resultadoValidacion = this.validarFormularioNru(nrucorreo);
		this.setState({ errores: resultadoValidacion });
		if (!Object.keys(resultadoValidacion).length) {
			servicioRecuperaFactura.recuperanru('recupera/factura.json', nrucorreo).then(response=>{
				let headers = response.headers;
        let encabezadoContent = headers['content-disposition'];
        let result = encabezadoContent.split(';')[1].trim().split('=')[1];
        let fileName = result.replace(/"/g, '');
				if(fileName.includes('No existe')){
					this.growl.show({life: 5000, severity: 'error', summary: 'Error Mensaje', detail: fileName });
					 }else{
						this.setState({ modalRecuperarNru: false,	nrucorreo:{} });
						this.growl.show({life: 5000, severity: 'success', summary: '\u00c9xito Mensaje', detail: "Se encontro su factura y ser\u00e1 enviado a la cuenta de correo ingresado" });
						servicioDescargaArchivos.imprimirFlujoBytesArchivo(response);
					 }
			}).catch(error=>{
			
			})
		}

	}

	ocultarModal=()=>{
		this.setState({ modalRecuperarNru: false });
	}



	render() {

		const { usuario, erroresFrmLogin,errores,nrucorreo } = this.state;

		const footer = (
			<div>
				<Button label="Recuperar" icon="pi pi-check" onClick={this.buscarFactura} />
				<Button label="Cancelar" icon="pi pi-times" onClick={this.ocultarModal} className="p-button-secondary" />
			</div>
		);

		return (
			<div>
				<Growl ref={(el) => this.growl = el} />
				<div className="p-grid">
					<div className="p-col-12 p-md-6">
						<img style={{ maxWidth: '100%', height: 'auto' }} src={logo} alt="Galleria 1" />
						<br />	<br />	<br />
						<div className="p-offset-1">
							<h3><p> Recupera tu factura por <ins>nru</ins> <Link onClick={this.recuperarFactura}>Aquí</Link></p></h3>
						</div>
					</div>
					<Dialog header="Recupera factura por NRU" visible={this.state.modalRecuperarNru} style={{ width: '50vw' }} onHide={this.ocultarModal} footer={footer}>
						<div className="p-grid p-fluid">
							<div className="p-col-12 p-md-6">
								<h4>*NRU:</h4>
								<InputText id="nru" keyfilter="num" name="nrucorreo.nru" value={nrucorreo.nru || ''} onChange={this.asignarValoresObjeto} className={errores.nru ? 'p-error' : ''}/>
								{errores.nru ? <div><br /> <Message severity="error" text={errores.nru} /> </div> : null}
							</div>
							<div className="p-col-12 p-md-6">
								<h4>* Correo recomendado @gmail,@hotmail:</h4>
								<InputText id="correo" name="nrucorreo.correo" value={nrucorreo.correo || ''} onChange={this.asignarValoresObjeto} className={errores.correo ? 'p-error' : ''} />
								{errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
							</div>
						</div>
					</Dialog>

					<div className="p-col-12 p-md-5 p-offset-1">
						<h1 className="text-base text-primary text-uppercase mb-4" style={{ color: '#4680ff' }}>Banobras</h1>
						<h2 className="mb-4">Facturación con registro!</h2>
						<p className="text-muted">Factura sin fronteras, rápido y confiable.</p>
						<div className="p-col"><NuevoRegistro /></div>
						<form onSubmit={this.login} method="POST">
							<div className="p-grid">
								<div className="p-col-12">
									<label htmlFor="usuario">Usuario:</label>
								</div>
								<div className="p-col-12">
									<div className="p-inputgroup">
										<span className="p-inputgroup-addon"><i className="pi pi-user" /></span>
										<InputText id="usuario" name="usuario.usuario" value={usuario.usuario || ''} onChange={this.asignarValoresObjeto} className={erroresFrmLogin.usuario ? 'p-error' : ''} placeholder="Usuario" size="40" />
									</div>
									{erroresFrmLogin.usuario ? <div><br /> <Message severity="error" text={erroresFrmLogin.usuario} /> </div> : null}
								</div>
								<div className="p-col-12">
									<label htmlFor="contrasena">Contraseña:</label>
								</div>
								<div className="p-col-12">
									<div className="p-inputgroup">
										<span className="p-inputgroup-addon"><i className="pi pi-unlock" /></span>
										<Password id="contrasena" name="usuario.contrasena" feedback={false} value={usuario.contrasena || ''} onChange={this.asignarValoresObjeto} className={erroresFrmLogin.contrasena ? 'p-error' : ''} placeholder="Contraseña" size="40" />
									</div>
									{erroresFrmLogin.contrasena ? <div><br /> <Message severity="error" text={erroresFrmLogin.contrasena} /> </div> : null}
								</div>
								<div className="p-col-12">
									<Button type="submit" label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ingresar&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" className="p-button-rounded p-button-info" />
								</div>
							</div>
						</form>

						<div className="p-grid">
							<div className="p-col-12">
								<RecuperarContrasena />
							</div>
							<div className="p-col-12">
								<Manual />
							</div>

							<div className="p-col-12">
								<h1>Para facturar sin registrarme click <Link to="/facturacionbanobras/facturacion-sin-registro">Aquí</Link></h1>
							</div>

							<div className="p-col-12">
								<h1>Números de atención a cliente:</h1>
								<br></br>
								<h2>55 120 91825</h2>
							</div>
						</div>
					</div>
				</div>
			</div>


		)
	}
}

export default Login;